export default {
    next: "Next",
    prev: "Back",
    submit: "Submit analysis request",
    contactInformation: "Contact Information",
    name: "Your Name",
    title: "Title",
    titles: [
        { id: "Mr.", name: "Mr."},
        { id: "Mrs.", name: "Mrs."},
    ],
    firstName: "First Name",
    lastName: "Last Name",
    company: "Company",
    country: "Country",
    city: "City",
    postalCode: "Postal Code",
    street: "Street",
    email: "Email",
    email2: "Additional Emails",
    phone: "Phone",
    emailTooltip: "Please provide one or more email addresses, separated by <strong>semicolons</strong>. The field should not contain spaces.",
    emailError: "Please provide a valid email address!",
    email2Error: "Please provide valid email addresses, separated by semicolons. The field should not contain spaces.",
    installationsTitle: "Details about your system",
    installationName: "System Name",
    location: "System Location",
    application: "Application",
    segment: "Segment",
    segmentPlaceholder: "Please select an application first",
    product: "Product",
    otherProduct: "Product Name",
    volume: "Total volume of fluid in your system (l)",
    volumeTooltip: "Please provide a number.<br/>If volume is unknown please provide your best guess",
    fillDate: "Date of First Fill",
    metals: "Metals Used in Your System",
    otherMetals: "Other Metals/Materials",
    sample: "Sample",
    addInstallation: "Add Sample",
    removeInstallation: "Remove Sample",
    removeConfirmation: "Are you sure you want to remove this sample?",
    installationRemoved: "The sample was removed.",
    other: "Other",
    listLoadError: "Unable to load drop list data. Please contact Clariant!",
    invalidFields: "You cannot continue to the next step while some fields have errors. Please check the fields marked in red!",
    extraInformation: "Additional Information",
    distributor: "Distributor where you bought our fluid",
    otherDistributor: "Other Distributor",
    dropdownPlaceholder: "Please select an option",
    feedback: "Comments and additional information about the sample",
    disclaimer1: "Once you have submitted the analysis request you will receive a confirmation email with your personal submission number and the postal address.",
    disclaimer2: "Samples sent in without submission numbers cannot be processed and will not be sent back.",
    startOver: "Submit another sample",
    confirmation: "Your request has been submitted. You should be receiving a confirmation email shortly.",
    confirmation2: "Meanwhile, you can download the confirmation receipt(s) and sample labels below: ",
    invalidEmailLength: "The combined length of both email fields cannot exceed 189 characters!",
    voucherNumber: "Voucher Number",
    noRemainingSamples: "The voucher number you provided is not valid",
    emptyVoucherMsg: "Please fill in the voucher number",
    counterVoucher: "Voucher",
    counterOutOf: "out of",
    counterAreAvailable: "samples are available",
    voucherIntro: "<p>Please fill out the form below. The <b>information you provide</b> will automatically be used to generate the <b>analysis report</b> and <b>printable bottle labels</b>.</p><p>You will receive a confirmation email containing your personal reference number and further instructions.</p><p><strong>Samples sent in without reference numbers will neither be processed nor sent back.</strong></p><p><strong>Third-party products will not be analysed and will be disposed of directly.</strong></p>",
    termsAndConditions: "<span>I agree to the <a href='Antifrogen-Sample-Submission/Terms-And-Conditions' target='_blank'>Terms &amp; Conditions</a>.",
    wrongAppVersion: "You are not running the latest version of this form. Please clear your browser cache and try again."
};